import React, { useRef, useState } from 'react';
import { useEffect } from 'react';
import client from '../client';
import ReactDOM from "react-dom/client";
import { PiSignOut } from 'react-icons/pi';

const UserProfileButton = () => {
    const [user,setUser] = useState(null);
    const buttonRef = useRef(null);
    const {getCurrent} = client;

    useEffect(() => {
        (async () => {
            await getCurrent()
            .then((response) => {
                if(response && response.user) {
                    setUser(response.user);
                }
            })
        })()

    },[])

  return (
    <button onClick={(e) => {
        e.stopPropagation();
        if(!buttonRef.current) return; 
        let buttonRect = buttonRef.current.getBoundingClientRect();
        let vw = document.documentElement.clientWidth;
        let vh = document.documentElement.clientHeight;
        const container = document.createElement("div");
        container.style.top = (buttonRect.bottom + 4)  + "px";
        container.style.right = (vw - buttonRect.right) + "px"; 
        container.style.width = 'auto';
        container.style.height = 'auto';
        container.style.position = 'fixed';
        container.style.zIndex = 100;
        container.style.overflow = 'hidden';
        container.classList.add('rounded-md')
        container.classList.add('shadow-2xl');
        document.body.appendChild(container);

        // Create a new React root
        const root = ReactDOM.createRoot(container);

        // Define cleanup function
        const close = () => {
            root.unmount();
            container.remove();
        };
        // Render the component into the container
        root.render(<Popup user={user} onClose={close}/>);
    }} ref={buttonRef} className='flex w-8 h-8 justify-center items-center rounded-full bg-white text-theme font-nunitoSansextraBold shrink-0'>
        {user && user.firstname && user.lastname? user.firstname.charAt(0).toUpperCase()+user.lastname.charAt(0).toUpperCase():''}
    </button>
  )
}

export default UserProfileButton

const Popup = ({user,onClose}) => {
    const {logout} = client;
    const popupRef = useRef(null)
    useEffect(() => {
        const handleClick = (event) => {
            /* if (popupRef.current && !popupRef.current.contains(event.target)) {
                onClose()
            } */
            onClose()
        };

        document.addEventListener("click", handleClick);

        return () => {
            document.removeEventListener("click", handleClick);
        };
    },[])

    return (
        <div ref={popupRef} className="flex flex-col w-52 h-72 bg-white rounded-md overflow-hidden">
			{user &&
			<div className="flex flex-col justify-between w-full h-full bg-white">
				<div className="flex w-full h-24 pt-8 justify-center bg-themeLight">
					<div className="flex w-32 h-32 rounded-full bg-theme shadow-lg">
						{user && (
							<p className="flex w-fit h-auto m-auto text-white text-7xl font-nunitoSansBold overflow-hidden">
								{user.firstname.charAt(0).toUpperCase() + user.lastname.charAt(0).toUpperCase()}
							</p>
						)}
					</div>
				</div>
				<div className="flex flex-col w-full space-y-4">
					<div className="flex flex-col justify-center items-center w-full h-fit space-y-2">
						<p className="text-2xl text-center text-text tracking-wide font-nunitoSansMedium capitalize">
							{user.name}
						</p>
						<p className="text-center font-nunitoSansRegular text-textFent tracking-wide capitalize">
							{`${user.firstname.toLowerCase()} ${user.lastname.toLowerCase()}`}
						</p>
					</div>
					<div className="flex w-full h-10 pl-4 items-center border-t border-theme">
						<button
							onClick={async (e) => {
                                e.preventDefault();
                                await logout()
                                .then(() => {
                                    window.location.href = "/";
                                })
                            }}
							className="flex flex-row space-x-4"
						>
							<PiSignOut size={20} className="text-theme" />
							<p className="text-sm text-text">Logout</p>
						</button>
					</div>
				</div>
			</div>
			}
		</div>
    )
}